import styled from 'styled-components';

const StyledLayoutBody = styled.div`
	position: absolute;
	display: flex;
	flex-direction: row;
	justify-content: center;
	column-gap: 60px;
	width: 100%;
	height: 100%;
	padding: 200px;
	background: #ece9e9 -webkit-gradient(linear, 0% 0%, 0% 100%, from(#fff), to(#ece9e9));
	background: #ece9e9 -moz-linear-gradient(top, #fff, #ece9e9);
	background-repeat: no-repeat;
`;

export { StyledLayoutBody };
